export const COLORS_COLORFUL = [
  "#ff5252",
  "#ff814a",
  "#ffb629",
  "#fce262",
  "#b3e364",
  "#56d681",
  "#25dae0",
  "#3bbff0",
  "#459bff",
  "#9280ff",
  "#bb81ff",
  "#ff7ce1",
];

export const COLORS_GREY = [
  "#ffffff",
  "#ededed",
  "#c9c9c9",
  "#909090",
  "#6c6c6c",
  "#121212",
];

export const snaTimePeriodOptions = [
  {
    key: "default",
    value: "default",
    label: "1929.1.1 - 1929.01.31(預設)",
    startDate: [1929, 1, 1],
    endDate: [1929, 1, 31],
  },
  {
    key: "taiwanWenHuaXieHua",
    value: "taiwanWenHuaXieHua",
    label: "1927.1.4以前 - 臺灣文化協會",
    startDate: [1927, 1, 1],
    endDate: [1927, 1, 4],
  },
  {
    key: "taiwanMinZhongDang",
    value: "taiwanMinZhongDang",
    label: "1927.1.5~1930.8.16 - 台灣民眾黨",
    startDate: [1927, 1, 5],
    endDate: [1930, 8, 16],
  },
  {
    key: "taiwanDiFangZiZhiLianMeng",
    value: "taiwanDiFangZiZhiLianMeng",
    label: "1930.8.17-1937.7.15 - 臺灣地方自治聯盟",
    startDate: [1930, 8, 17],
    endDate: [1937, 7, 15],
  },
];

// 林獻堂,蔡培火,葉榮鐘日誌涵蓋的範圍
const periodRange = { startDate: [1927, 1, 1], endDate: [1984, 12, 30] };

// defaultPeriod 改成 '1927.1.5~1930.8.16 - 台灣民眾黨' => 圖比較漂亮
// const defaultPeriod = { startDate: [1927, 1, 5], endDate: [1930, 8, 16] };
// 避免資料量過大, 以致 render 太久, 所以設定 一個月的 period
const defaultPeriod = { startDate: [1929, 1, 1], endDate: [1929, 1, 31] };
const getDate = (dateArr) => new Date(dateArr[0], dateArr[1] - 1, dateArr[2]);

export const getPeriodStart = () => getDate(periodRange.startDate);
export const getPeriodEnd = () => getDate(periodRange.endDate);

const getDateTxt = (dateArr) => `${dateArr[0]}/${dateArr[1]}/${dateArr[2]}`;
export const getPeriodStartTxt = () => getDateTxt(periodRange.startDate);
export const getPeriodEndTxt = () => getDateTxt(periodRange.endDate);

export const getStartEndDate = (period) => [
  getDate(period.startDate),
  getDate(period.endDate),
];

export const getDefaultStartEndDate = () => [
  getDate(defaultPeriod.startDate),
  getDate(defaultPeriod.endDate),
];

const toYYYYorMMorDD = (str) => {
  if (str.length === 4) return str;
  return str.length === 2 ? str : `0${str}`;
};

export const getISOString = (date) => {
  if (date instanceof Date) {
    // date.toLocaleDateString() : Fri Jan 04 1929 00:00:00 GMT+0800 => '1929/1/4'
    // .split("/").map((o) => toYYYYorMMorDD(o)).join("-"): '1929/1/4'  => '1929-01-04'
    return (
      date
        // 使用 zh_TW, format 格式為 yyyy/mm/dd
        .toLocaleDateString("zh-TW")
        .split("/")
        .map((o) => toYYYYorMMorDD(o))
        .join("-")
    );

    // Fri Jan 04 1929 00:00:00 GMT+0800  => '1929-01-03T16:00:00.000Z'
    // return date.toISOString().substring(0, 10);
  }
  if (typeof date === "string") {
    return date;
  }
  return date;
};

// 節點計數方式
export const countOptions = [
  {
    key: "meetAuthCount",
    label: "節點數為與作者見面次數",
  },
  {
    key: "meetOthersCount",
    label: "與其他人物的總鏈結次數",
  },
];

export const SNA_BASIC_SETTING = {
  // adjust
  adjust_nodeColors: COLORS_COLORFUL,
  adjust_linkColors: COLORS_GREY,
  adjust_nodePlaceMode: "centerAndEdge",
  adjust_nodeShowNodeCount: "false",
  adjust_nodeDispersion: "5",
  adjust_legendShowNodDataGroup: "true",
  // filter
  filter_nodeCount: "1",
  filter_linkCount: "1",
  filter_limitTotalNodesCount: 250, // 限制顯示節點數
  filter_timePeriod: snaTimePeriodOptions[0].value,
  filter_startEndDate: getDefaultStartEndDate(),
  filter_eventTypeOn: false,
  // filter_nodeCountMeetAuth: false,
  filter_nodeCountMeetAuthNew: countOptions[0].key,
  //
  analytics_type: "",
  // import

  // export
  export_imageResolution: "",
  export_imageMineType: "",
  export_fileMineType: "",
  export_startExportFile: false,
  export_startExportImage: false,
};

export const IMG_SETTING = {
  jpg: {
    name: "jpg",
    mineType: "image/jpeg",
    extension: "jpeg",
  },
  png: {
    name: "png",
    mineType: "image/png",
    extension: "png",
  },
};

// export const EXPORT_FILE_SETTING = {
//   csv: {
//     name: "csv",
//     mineType: "text/csv;charset=utf8",
//     extension: "csv",
//   },
// };

export const SNA_ANALYTICS_CATEGORY = {
  centrality: "centrality",
  pageRank: "pageRank",
  all: "all",
};

const degreeCentralityDesc = [
  "*人氣度-「點度中心性(degree centrality)」：即該節點與其它節點直接連接的總數，數量愈多，代表它有將消息散播給數以百萬計的節點，擁有足以影響眾人觀點的力量。以臉書為例：A有好友100個，B有好友1000個，則B於這個社交網絡中扮演較為重要的角色。",
  (persons) => `目前數據結果顯示，${persons} 擁有較高的人氣度。`,
];
const betweenCentralityDesc = [
  "*媒合與橋梁-「中介中心性(betweenness centrality)」：即不同族群間的關鍵橋樑，必須透過它才有辦法聯繫其它人，能讓原本互不往來的族群開始接觸彼此。是網絡中強而有力的媒合者、關鍵的中介者及網絡位置得天獨厚的協調者。",
  (persons) =>
    `目前數據結果顯示，${persons} 是網絡中關鍵的橋樑角色，連結著不同的次群體。`,
];
const closeCentralityDesc = [
  "「接近中心性(closeness centrality)」：即該節點與網絡中各節點的最近距離程度，像是車站、捷運站等公共設施應設在接近中心性最高的地方，儘可能讓所有人離它愈近愈好。而接近中心性高的節點一般也是八卦傳播者，他們不一定是名人，但是樂於在不同的人群之間傳遞消息。",
  (persons) =>
    `目前數據結果顯示，${persons} 非常適合作為在所屬群體中之訊息傳播者。`,
];
const eigenvectorCentralityDesc = [
  "*連結度(關鍵是你認識誰)-「特徵向量中心性 Eigenvector centrality」：即該節點在網絡中連結重要節點的程度。結交越多朋友當然越好，但結交一些網絡位置絕佳的朋友也很重要，有時候甚至更加重要。",
  (persons) =>
    `目前數據結果顯示，${persons} 擁有較高的連結度，認識更多的關鍵人物。`,
];

export const SNA_ANALYTICS_DESC = {
  degreeCentrality: degreeCentralityDesc,
  degreeCentralityStd: degreeCentralityDesc,
  betweenCentrality: betweenCentralityDesc,
  betweenCentralityStd: betweenCentralityDesc,
  closeCentrality: closeCentralityDesc,
  eccentriCentrality: "eccentriCentrality",
  eigenvectorCentrality: eigenvectorCentralityDesc,
  pageRank:
    "PageRank的結果來源於一種基於圖論的數學演算法。它將全球資訊網上所有的網頁視作節點（node），而將超連結視作邊（edge），並且考慮到了一些權威的網站，類似CNN。每個節點的權重值表示對應的頁面的重要度。通向該網頁的超連結稱做「對該網頁的投票（a vote of support）」。每個網頁的權重值大小被遞迴地定義，依託於所有連結該頁面的頁面的權重值。例如，一個被很多頁面的連結的頁面將會擁有較高的權重值（high PageRank）。",
  completeAnalysis: [
    degreeCentralityDesc,
    betweenCentralityDesc,
    closeCentralityDesc,
    eigenvectorCentralityDesc,
  ],
};

export const SNA_ANALYTICS_LINK = {
  degreeCentrality:
    "https://en.wikipedia.org/wiki/Centrality#Degree_centrality",
  degreeCentralityStd:
    "https://en.wikipedia.org/wiki/Centrality#Degree_centrality",
  betweenCentrality:
    "https://en.wikipedia.org/wiki/Centrality#Betweenness_centrality",
  betweenCentralityStd:
    "https://en.wikipedia.org/wiki/Centrality#Betweenness_centrality",
  closeCentrality:
    "https://en.wikipedia.org/wiki/Centrality#Closeness_centrality",
  eccentriCentrality: "https://en.wikipedia.org/wiki/Distance_(graph_theory)",
  eigenvectorCentrality:
    "https://zh.wikipedia.org/zh-tw/%E7%89%B9%E5%BE%81%E5%90%91%E9%87%8F%E4%B8%AD%E5%BF%83%E6%80%A7",
  pageRank: "https://zh.wikipedia.org/zh-tw/PageRank",
};

// 數據分析類型
/** 說明:
 * countMethod: 用在"篩選"時的"節點數定義選項"選單
 * */
export const SNA_ANALYTICS_TYPE = {
  /** ====== centrality ====== */
  degreeCentrality: {
    category: SNA_ANALYTICS_CATEGORY.centrality,
    key: "degreeCentrality",
    label: "度中心性 Degree centrality",
    countMethod: false,
  },
  degreeCentralityStd: {
    category: SNA_ANALYTICS_CATEGORY.centrality,
    key: "degreeCentralityStd",
    label: "度中心性 Degree centrality(標準化)",
    countMethod: true,
  },
  betweenCentrality: {
    category: SNA_ANALYTICS_CATEGORY.centrality,
    key: "betweenCentrality",
    label: "中間性中心性 Between centrality",
    countMethod: false,
  },
  betweenCentralityStd: {
    category: SNA_ANALYTICS_CATEGORY.centrality,
    key: "betweenCentralityStd",
    label: "中間性中心性 Between centrality(標準化)",
    countMethod: true,
  },
  closeCentrality: {
    category: SNA_ANALYTICS_CATEGORY.centrality,
    key: "closeCentrality",
    label: "接近性中心性 Closeness centrality(標準化)",
    countMethod: true,
  },
  eigenvectorCentrality: {
    category: SNA_ANALYTICS_CATEGORY.centrality,
    key: "eigenvectorCentrality",
    label: "特徵向量中心性 Eigenvector centrality",
    countMethod: true,
  },
  // eccentriCentrality: {
  //   category: SNA_ANALYTICS_CATEGORY.centrality,
  //   key: "eccentriCentrality",
  //   label: "Eccentricity centrality",
  // },
  /** ====== pageRank ====== */
  pageRank: {
    category: SNA_ANALYTICS_CATEGORY.pageRank,
    key: "pageRank",
    label: "Page rank",
    countMethod: false,
  },
  completeAnalysis: {
    category: SNA_ANALYTICS_CATEGORY.all,
    key: "completeAnalysis",
    label: "完整分析",
    countMethod: false,
  },
};

// 事件類別的 class
export const EVENT_TYPE_CLASS = {
  // EventType:語意分析事件類別的 class
  EventType: "EventType",
  // KinshipEventType:林獻堂的親屬關係事件類別的 class. // pseudo class(並非真有這個class,是為了把親屬事件與其他事件整合在一起而定義一個新的 class)
  KinshipEventType: "KinshipEventType",
};
